


import {BrowserRouter as Router,Routes,Route} from "react-router-dom"
import Home from "./Home";
import Error from "./Error";
import ProjectPlanner from './Project-planner.js'

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="*" element={<Error/>}/>
        </Routes>
      </Router>
    </>
  );
}

export default App;
